<script>

  import { getContext, onMount } from "svelte";
  import { SubscriptionTypes } from "@Store";
  import {API} from "@API";

  let {org} = getContext("SHOP");

  let CreateUserService = API.service('users/createFullAccount')

  console.log(org)

  onMount(async ()=>{
    await SubscriptionTypes.refresh({
      nme:"TFC Subscription"
    });
  })

  async function purchase(){

    CreateUserService.post({
      Email:"kyle+test@northkode.com",
      FirstName:"Kyle",
      LastName:"Jeske",
      org:org.guid
    })
  }

</script>

<style type="text/scss">

</style>

<h1>Welcome To: {org.nme}</h1>

<button on:click={purchase}>Purchase</button>
